import ValidateEmail from '../rules/email';

const PersonFormValidation = (values) => {
  const errors = {};

  values = values.toJS(); // eslint-disable-line

  errors.email = ValidateEmail(values.email);

  return errors;
};

export default PersonFormValidation;



// WEBPACK FOOTER //
// ./src/components/validation/forms/personFormValidator.js